export default "__VITE_ASSET__DgjoMY8r__"